import { action } from 'typesafe-actions';
import { HeaderTypes } from './types';

export const showHeader = () => action(HeaderTypes.SHOW_HEADER);
export const hideHeader = () => action(HeaderTypes.HIDE_HEADER);
export const showHeaderMenu = () => action(HeaderTypes.SHOW_HEADER_MENU);
export const hideHeaderMenu = () => action(HeaderTypes.HIDE_HEADER_MENU);
